import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Rebecca is the most talented UX professional I have worked with in the healthcare space, offering that unique combination of industry knowledge, a customer-first mindset, and a breadth of UX capabilities.',
  author: 'Heather Ritchie',
  role: 'COO',
  company: 'Embr Labs'
}, {
  quote: "Beyond Rebecca's UX expertise, she is a joy to collaborate with - thoughtful, optimistic, and always bringing fresh perspectives to every discussion.",
  author: 'Maria Pis-Lopez',
  role: 'Director of PM',
  company: 'Ginkgo Biosecurity'
}, {
  quote: "Rebecca's thoughtful and insightful approach was instrumental in bringing my idea to life. Her ability to translate our conversations into a state-of-the-art app was impressive",
  author: 'Barbara Alex',
  role: 'Founder',
  company: 'Root Beliefs'
}];
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="flex-shrink-0 w-[384px] h-[280px] bg-white rounded-xl shadow-sm border border-slate-200 p-6 flex flex-col" data-id="element-225">
      <div className="mb-4 text-blue-400" data-id="element-226">
        <Quote size={24} className="opacity-40" data-id="element-227" />
      </div>

      <blockquote className="flex-grow mb-6" data-id="element-228">
        <p className="text-sm text-slate-700 font-light leading-relaxed line-clamp-6" data-id="element-229">
          "{testimonial.quote}"
        </p>
      </blockquote>

      <div className="mt-auto border-t border-slate-100 pt-4" data-id="element-230">
        <p className="font-medium text-slate-900 text-sm" data-id="element-231">
          {testimonial.author}
        </p>
        <p className="text-xs text-slate-500" data-id="element-232">{testimonial.role}</p>
        <p className="text-xs text-blue-600 font-medium" data-id="element-233">
          {testimonial.company}
        </p>
      </div>
    </div>;
}
export function Testimonials() {
  const [isPaused, setIsPaused] = useState(false);
  const [offset, setOffset] = useState(0);
  const cardWidth = 384 + 24; // 384px (w-[384px]) + 24px gap
  const totalWidth = cardWidth * testimonials.length;
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setOffset(prev => {
        const newOffset = prev - 1;
        // Reset when we've scrolled past the first set
        if (Math.abs(newOffset) >= totalWidth) {
          return 0;
        }
        return newOffset;
      });
    }, 30);
    return () => clearInterval(interval);
  }, [isPaused, totalWidth]);
  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials, ...testimonials];
  return <section className="py-12 bg-slate-50 overflow-hidden" data-id="element-234">
      <div className="mb-8 text-center" data-id="element-235">
        <p className="text-sm uppercase tracking-widest text-slate-500 font-light" data-id="element-236">
          Kind words from collaborators
        </p>
      </div>

      <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-237">
        <motion.div className="flex gap-6" animate={{
        x: offset
      }} transition={{
        type: 'tween',
        ease: 'linear',
        duration: 0
      }} data-id="element-238">
          {duplicatedTestimonials.map((testimonial, index) => <TestimonialCard key={`${testimonial.author}-${index}`} testimonial={testimonial} data-id="element-239" />)}
        </motion.div>
      </div>
    </section>;
}